export const PDFJS_CONFIG = 'pdfjsConfig';

export class pdfJsConfiguration {
    CMAP_URL;
    CMAP_PACKED;

    constructor(ecareEnv: string) {
        this.CMAP_URL = `https://assets.ecarevault.com/${ecareEnv}/src/client/assets/cmaps/`;
        this.CMAP_PACKED = true;
    }
}


